/* KK Infinite Feed — scroll infinito para featured-collection con tabs.
   Pagina la colección del tab activo vía Section Rendering API (sections/kk-feed.liquid). */
(function () {
  'use strict';

  function initAll() {
    document.querySelectorAll('.kk-feed-sentinel').forEach(function (sentinel) {
      var wrapper = sentinel.closest('.section__wrapper');
      if (!wrapper || wrapper.dataset.kkFeedInit) return;
      wrapper.dataset.kkFeedInit = '1';
      setup(wrapper, sentinel);
    });
  }

  function setup(wrapper, sentinel) {
    var perPage = parseInt(sentinel.dataset.kkPerPage || '25', 10);
    var states = {}; // handle -> { done, loading }

    function activePanel() {
      var panels = wrapper.querySelectorAll('.tabs__panels > .tabs__panel');
      for (var i = 0; i < panels.length; i++) {
        if (!panels[i].hidden) return panels[i];
      }
      return panels[0] || null;
    }

    function stateFor(handle) {
      if (!states[handle]) states[handle] = { done: false, loading: false };
      return states[handle];
    }

    function loadMore() {
      var panel = activePanel();
      if (!panel) return;
      var handle = panel.dataset.collectionHandle;
      var total = parseInt(panel.dataset.total || '0', 10);
      if (!handle) return;
      var st = stateFor(handle);
      if (st.done || st.loading) return;

      var grid = panel.querySelector('.featured-collection__items');
      if (!grid) return;
      var loaded = grid.querySelectorAll('.f-column').length;
      if (total && loaded >= total) {
        st.done = true;
        sentinel.classList.remove('is-loading');
        return;
      }

      var page = Math.floor(loaded / perPage) + 1;
      st.loading = true;
      sentinel.classList.add('is-loading');

      fetch('/collections/' + handle + '?page=' + page + '&section_id=kk-feed')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.kk-feed__item');
          if (!items.length) { st.done = true; return; }
          items.forEach(function (item) { grid.appendChild(document.importNode(item, true)); });
          if (items.length < perPage) st.done = true;
        })
        .catch(function () { st.done = true; })
        .then(function () {
          st.loading = false;
          sentinel.classList.remove('is-loading');
          // si el sentinel sigue visible (pantallas altas), seguir cargando
          requestAnimationFrame(function () {
            if (isVisible(sentinel)) loadMore();
          });
        });
    }

    function isVisible(el) {
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight || document.documentElement.clientHeight) + 800;
    }

    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadMore();
      },
      { rootMargin: '800px 0px' }
    );
    io.observe(sentinel);

    // al cambiar de tab, evaluar el nuevo panel
    wrapper.addEventListener('tabChange', function () {
      setTimeout(loadMore, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
